var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9045_12685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5013 6.60476C20.9269 3.52914 26.2207 3.63122 29.5209 6.93726C32.8196 10.2448 32.9334 15.5123 29.8651 18.9481L17.4984 31.3323L5.13464 18.9481C2.0663 15.5123 2.18151 10.236 5.4788 6.93726C8.78193 3.6356 14.0655 3.52476 17.5013 6.60476ZM27.4559 8.99789C25.2684 6.80747 21.7392 6.71851 19.4496 8.77476L17.5028 10.5218L15.5544 8.77622C13.2576 6.71705 9.73568 6.80747 7.54235 9.0008C5.36943 11.1737 5.26005 14.6518 7.26235 16.9502L17.4998 27.2037L27.7373 16.9516C29.7411 14.6518 29.6317 11.1781 27.4559 8.99789Z",
    fill: "#093549"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9045_12685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeLine);
export default __webpack_public_path__ + "static/media/like-line.d0ddea017c8ddef3d23234809d0503dc.svg";
export { ForwardRef as ReactComponent };